import { Flash, Link } from '@acast/decibel';
import config from 'app/config';
import T from 'prop-types';
import React, { Component } from 'react';
import { getUserToken, isUserAuthenticated } from 'services/authentication';
import Container from 'shared/components/content-container';
import PendingPage from 'shared/components/pending-page';
import navigateTo from 'shared/helpers/navigate-to';
import redirectToSignup from 'shared/helpers/redirect-to-signup';
import superagent from 'superagent';

class RedeemInvite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      error: null,
    };
  }

  componentDidMount() {
    if (!isUserAuthenticated()) {
      redirectToSignup(window.location.pathname);
    } else {
      const { inviteId } = this.props.routeParams;
      this.redeemInviteRequest(inviteId);
    }
  }

  redeemInviteRequest(inviteId) {
    superagent
      .post(`${config.get('CREATE_API_HOST')}/api-v3/me/invites/${inviteId}`)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .end(error => {
        if (error) {
          this.setState({
            error: error.response.status,
            isLoading: false,
          });
        } else {
          navigateTo('/overview');
        }
      });
  }

  renderErrorMessage(errorCode) {
    if (errorCode === 404) {
      return (
        <Flash intent="danger" data-test-id="Redeem__Error--invalid-url">
          The invite has expired or is invalid, please contact Acast support at{' '}
          <Link href="mailto:support@acast.com">support@acast.com</Link> to get a new invite.
        </Flash>
      );
    }

    return (
      <Flash intent="danger" data-test-id="Redeem__Error">
        Something went wrong when trying to redeem this invite. Please contact Acast support at{' '}
        <Link href="mailto:support@acast.com">support@acast.com</Link> to get a new invite.
      </Flash>
    );
  }

  render() {
    if (this.state.isLoading) {
      return <PendingPage />;
    }

    if (this.state.error) {
      return <Container>{this.renderErrorMessage(this.state.error)}</Container>;
    }

    return null;
  }
}

RedeemInvite.propTypes = {
  routeParams: T.shape({
    inviteId: T.string.isRequired,
  }).isRequired,
};

export default RedeemInvite;
